import { styled } from "@mui/material";

const Container = styled("div")`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  position: relative;
  border-bottom: solid 1px #e3e6e9;
`;
const Connector = styled("div")`
  position: absolute;
  width: 70%;
  height: 3px;
  background: #007cbf;
  left: 15%;
  top: 40px;
`;

const ProgressIcon = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9;
`;

const Step = styled("div", {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive: boolean }>`
  width: 40px;
  height: 40px;
  color: ${({ isActive }) => (isActive ? "white" : "#1f1f1fa6")};
  border-radius: 50%;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.palette.primary.main : "white"};
  transition: background-color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid 1px
    ${({ isActive, theme }) =>
      isActive ? theme.palette.primary.main : "#0000001a"};
`;

export { Container, Connector, ProgressIcon, Step };
